module.exports = __webpack_public_path__ + "img/eoy-impact-2.470460c7.jpg";